import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export default function Privacy() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gradient-hero text-primary-foreground">
      <Helmet>
        <title>{t("legal.privacy.metaTitle")}</title>
        <meta name="description" content={t("legal.privacy.metaDesc")} />
        <link rel="canonical" href="https://tipomatic.app/privacy" />
        <meta property="og:title" content={t("legal.privacy.metaTitle")} />
        <meta property="og:description" content={t("legal.privacy.metaDesc")} />
        <meta property="og:url" content="https://tipomatic.app/privacy" />
      </Helmet>

      <header className="container mx-auto px-4 py-5 flex items-center justify-between">
        <div className="flex items-center gap-2 font-bold text-lg">
          <img src="/icon-512.png?v=2" alt="Tipomatic" className="h-8 w-8 rounded-lg object-cover" />
          Tipomatic
        </div>
        <Button asChild variant="ghost" className="text-pitch-cream hover:bg-white/10 hover:text-pitch-cream">
          <Link to="/"><ChevronLeft className="mr-1 h-4 w-4" /> {t("legal.back")}</Link>
        </Button>
      </header>

      <main className="container mx-auto px-4 py-12 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold mb-8">{t("legal.privacy.title")}</h1>

        <div className="space-y-8 text-pitch-cream/80 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-pitch-cream mb-2">{t("legal.privacy.s1Title")}</h2>
            <p>{t("legal.privacy.s1Body")}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-pitch-cream mb-2">{t("legal.privacy.s2Title")}</h2>
            <ul className="list-disc list-inside space-y-1 mt-2">
              <li><strong>{t("legal.privacy.s2Item1Label")}</strong>{t("legal.privacy.s2Item1Body")}</li>
              <li><strong>{t("legal.privacy.s2Item2Label")}</strong>{t("legal.privacy.s2Item2Body")}</li>
              <li><strong>{t("legal.privacy.s2Item3Label")}</strong>{t("legal.privacy.s2Item3Body")}</li>
            </ul>
          </section>

          {[3, 4, 5].map((n) => (
            <section key={n}>
              <h2 className="text-lg font-semibold text-pitch-cream mb-2">{t(`legal.privacy.s${n}Title`)}</h2>
              <p>{t(`legal.privacy.s${n}Body`)}</p>
            </section>
          ))}

          <section>
            <h2 className="text-lg font-semibold text-pitch-cream mb-2">{t("legal.privacy.s6Title")}</h2>
            <p>
              {t("legal.privacy.s6BodyPrefix")}
              <a href="mailto:notify@tipomatic.app" className="text-primary underline">notify@tipomatic.app</a>.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-pitch-cream mb-2">{t("legal.privacy.s7Title")}</h2>
            <p>{t("legal.privacy.s7Body")}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-pitch-cream mb-2">{t("legal.privacy.s8Title")}</h2>
            <p>{t("legal.privacy.s8Body")}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-pitch-cream mb-2">{t("legal.privacy.s9Title")}</h2>
            <p>
              {t("legal.privacy.s9BodyPrefix")}
              <a href="mailto:notify@tipomatic.app" className="text-primary underline">notify@tipomatic.app</a>.
            </p>
          </section>
        </div>
      </main>

      <footer className="border-t border-pitch py-8 text-center text-pitch-cream/40 text-sm">
        {t("legal.footer")}
      </footer>
    </div>
  );
}
